import {ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef} from '@angular/core';
import {ComponentCellOptions} from './cbj-datatable.models';
export class CbjCompCellDirective implements OnInit {
   cbjCompCell: ComponentCellOptions;
/**
 * @param {?} viewContainerRef
 * @param {?} cfr
 */
constructor(private viewContainerRef: ViewContainerRef,
private cfr: ComponentFactoryResolver) {
  }
/**
 * @return {?}
 */
ngOnInit() {
    const /** @type {?} */ compFactory = this.cfr.resolveComponentFactory(this.cbjCompCell.component);
    const /** @type {?} */ compRef = this.viewContainerRef.createComponent(compFactory);
    ( /** @type {?} */((<any>compRef.instance))).row = this.cbjCompCell.row;
    ( /** @type {?} */((<any>compRef.instance))).keys = this.cbjCompCell.keys;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[cbjCompCell]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
{type: ComponentFactoryResolver, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cbjCompCell': [{ type: Input, args: ['cbjCompCell', ] },],
};
}

function CbjCompCellDirective_tsickle_Closure_declarations() {
/** @type {?} */
CbjCompCellDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjCompCellDirective.ctorParameters;
/** @type {?} */
CbjCompCellDirective.propDecorators;
/** @type {?} */
CbjCompCellDirective.prototype.cbjCompCell;
/** @type {?} */
CbjCompCellDirective.prototype.viewContainerRef;
/** @type {?} */
CbjCompCellDirective.prototype.cfr;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
